import EcoButton from 'eco-design/base/eco-button';
import EcoImg from 'eco-design/base/eco-img';
import GloLayout from 'lowcode/common/GloLayout';
import { useRouter } from 'next/router';
import './index.scss';

export default function Content({ id, data = {} }: any) {
    const { title, desc, btnText1, btnHref1, btnText2, btnHref2, pc, h5, imgScale } = data;
    const { locale, asPath } = useRouter();
    const pathnameA = `/${locale}${asPath}`;
    const compStyle = {
        '--editor-blog-product-item-a-scale': imgScale || 1,
    };

    const dataLayer1 = {
        event: 'uaEvent',
        event_name: 'buy',
        product_name: title,
        position: `blog_${pathnameA}`,
        display_type: 'blog_product_item_a',
        module_referral: 'blog_product_item_a',
        jump_module: 'blog_product_item_a',
        url: btnHref1,
        __btn_id1: `editor-blog-product-item-a`,
        __btn_id2: btnHref1,
        __btn_type: 'href',
    };
    const dataLayer2 = {
        event: 'uaEvent',
        event_name: 'select_product',
        list_name: 'none',
        product_name: title,
        button_name: `${btnText2 || ''}_blog`,
        __btn_id1: `editor-blog-product-item-a`,
        __btn_id2: btnHref2,
        __btn_type: 'href',
    };
    return (
        <GloLayout className={`editor-blog-product-item-a`} id={id} style={compStyle}>
            <div className="editor-blog-product-item-a-content">
                <div className="editor-blog-product-item-a-l">
                    <EcoImg pc={pc} h5={h5} />
                </div>
                <div className="editor-blog-product-item-a-r">
                    {title && <h2 className="editor-blog-product-item-a-title">{title}</h2>}
                    {desc && <div className="editor-blog-product-item-a-desc">{desc}</div>}
                    <div className="editor-blog-product-item-a-btn-box">
                        {btnText2 && btnHref2 && (
                            <EcoButton
                                lChildren={btnText2}
                                lHref={btnHref2}
                                className="editor-blog-product-item-a-btn editor-blog-product-item-a-btn-more GtmModuleData-btn-href"
                                lDataLayer={dataLayer2}
                            />
                        )}
                        {btnText1 && btnHref1 && (
                            <EcoButton
                                lChildren={btnText1}
                                lHref={btnHref1}
                                className="editor-blog-product-item-a-btn GtmModuleData-btn-href"
                                lDataLayer={dataLayer1}
                            />
                        )}
                    </div>
                </div>
            </div>
        </GloLayout>
    );
}
